export enum FormState {
  Add = 'Add',
  Modify = 'Modify',
  Static = 'Static'
}
